
import React, { useContext, useState } from "react";
import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Button,
  Avatar,
  Typography,
} from "antd";
import { useNavigate, NavLink } from "react-router-dom";

import face2 from "../../assets/images/face-2.jpg";
import { useEffect } from "react";
import {changeUserPassword, deleteUser, fetchAllUsers} from "../../services/user.service";
import {getTimeAgo, noAccess} from "../../utils/common";
import { extractPermissions } from "../../utils/user.util";
import DeleteItemModal from "../../components/layout/DeleteItemModal";
import { showSuccessMessage } from "../../utils/notification.util";
import { groupedCheckboxesPreview } from "./util";
import { GlobalContext } from "../../context/GlobalContext";
import {roles, roleValues} from "../../config/roles";
import ChangePasswordModal from "./Modals/ChangePassword";

const { Title } = Typography;
// table code start
const columns = [
  {
    title: "Staff Member",
    dataIndex: "name",
    key: "name",
    // width: "32%",
  },
  // {
  //   title: "Survivor Permission",
  //   key: "location",
  //   dataIndex: "location",
  // },
  // {
  //   title: "Interview Permission",
  //   key: "interview",
  //   dataIndex: "interview",
  // },
  {
    title: "STATUS",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "ROLE",
    key: "role",
    dataIndex: "role",
  },{
    title: "District",
    key: "district",
    dataIndex: "district",
  },
  {
    title: "CREATED DATE",
    key: "created",
    dataIndex: "created",
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
  },
];

function UserManagement() {
  const { setBreadCrumb, user } = useContext(GlobalContext);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const onChange = (e) => console.log(`radio checked:${e.target.value}`);
  useEffect(() => {
    loadDataFromServer();
    setBreadCrumb([
      {
        title: 'Users',
        link: `/user-management`,
      },
    ])
    if(user?.role !== roleValues.admin ) {
      noAccess();
    }
  }, []);
  const handleDelete = (user) => {
    deleteUser(user.uuid).then(() => {
      showSuccessMessage(`${user.fullName} deleted successfully!`);
      loadDataFromServer();
    }).catch((error) => console.log(error));
  };
  const handleChangePassword = (_user, newPassword) => {
    changeUserPassword(_user.uuid, newPassword).then(() => {
      showSuccessMessage(`${user.fullName}: password changed successfully!`);
    }).catch((error) => console.log(error));
  }
  const loadDataFromServer = () => {
    fetchAllUsers()
      .then((response) => {
        const data = response.data.map((_user) => {
          const permissions = extractPermissions(_user.permissions);
          return {
            key: _user.uuid,
            name: (
              <>
                <Avatar.Group>
                  {/* <Avatar
                    className="shape-avatar"
                    shape="square"
                    size={40}
                    src={face2}
                  ></Avatar> */}
                  <div className="avatar-info">
                    <Title level={5}>{_user.fullName}</Title>
                    <p>{_user.email}</p>
                  </div>
                </Avatar.Group>{" "}
              </>
            ),
            // location: (
            //   <>
            //     {groupedCheckboxesPreview(['create', 'view', 'edit', 'delete'], permissions.location)}
            //   </>
            // ),
            // interview: (
            //   <>
            //     {groupedCheckboxesPreview(['create', 'view', 'edit', 'delete'], permissions.interview)}
            //   </>
            // ),
            status: (
              <>
                {_user.isVerified && <Button type="primary" className="tag-primary">
                  ACTIVE
                </Button>}
                {!_user.isVerified && <Button className="tag-badge">PENDING</Button>}
              </>
            ),
            role: (
              <>
                {roles.find(x => x.value === _user.role)?.label}
              </>
            ),
            district: (
                <>
                  {_user.district}
                </>
            ),
            created: (
              <>
                <div className="ant-employed">
                  <span>{getTimeAgo(_user.createdAt)}</span>
                </div>
              </>
            ),
            action: (
              <>
                <NavLink to={`/user-management/edit/${_user.uuid}`}>Edit</NavLink> &nbsp; <DeleteItemModal onDelete={handleDelete} item={_user} />
                {user.role === roleValues.admin && (<ChangePasswordModal changePassowrd={handleChangePassword} item={_user} />)}
              </>
            )
          };
        });
        setUsers(data);
      })
      .catch((error) => console.log(error));
  }
  return (
    <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Authorized Staff"
              extra={
                <Button type="primary" className="tag-primary" onClick={() => navigate('/user-management/add-user')}>
                  Add Authorized Person
                </Button>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={users}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
  );
}

export default UserManagement;
